//判断是否看过公告

export default {
  getRecord(arr,that){
    // console.log("console.log(this)", this)
    let datas = arr
    let recordsArr = JSON.parse(JSON.stringify(window.localStorage.getItem("records"))).split(',')

    for(let i in datas){

      for(let z in recordsArr){
        if(recordsArr[z]==datas[i].id){
          datas[i].recordState = true
        }
      }
    }

    return datas

  }

}

